import { formatMoney } from '@/utils/Payment';

export const getFormatValue = (price, currency) => {
  if (!price) return null;

  const value = formatMoney(Math.round(price));

  return currency === 'SEK'
    ? `
${value} ${currency}`
    : `${currency}
${value}`;
};

export const getHasDiscountTitle = (hasDiscount, price) => {
  if (hasDiscount) {
    const discount = price?.regular?.totalPrice - price?.discount?.totalPrice;

    return discount >= price?.regular?.totalPrice * 0.1;
  }
};

export const getTitleMoneyPerDayValue = (
  price,
  cleaningFee = 0,
  daysAmount,
  currency,
) => {
  if (!price) return null;

  const amount = formatMoney(
    Math.floor(Number(price.totalPrice - cleaningFee) / daysAmount),
  );

  return currency === 'SEK'
    ? `${amount} ${currency}`
    : `${price.currency} ${amount}`;
};
